import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  bottomSheet: {
    backgroundColor: colors.backgroundL0,
  },
  // Top padding sits on the measured content container; on the scroll view's
  // own style the dynamic sheet comes out 12dp short and the footer covers it.
  background: {
    backgroundColor: colors.backgroundL0,
    paddingTop: theme.spacing[4],
    paddingHorizontal: theme.spacing[4],
    gap: theme.spacing[7],
  },
  footer: {
    paddingTop: theme.spacing[7],
    paddingHorizontal: theme.spacing[4],
    paddingBottom: rt.insets.bottom + theme.spacing[4],
  },
}));
